export default class Utils {
	static handleFiltersToHashUrl(sField, sValue) {
		//TODO: remove
		// call with no args to clear filters.
		let initSQ = '';
		let defaultQuery = 'search=';
		let updatedHash = null;
		let currHash = decodeURI(location.hash);
		if (currHash.indexOf(defaultQuery) > -1) {
			let searchRegx = /search=(\w|\s|-|\.|#|\+)+/gm;
			let searchQArr = currHash.match(searchRegx);
			if (searchQArr[0].length) {
				initSQ = searchQArr[0]; // My need to codeURI
			}
		}
		if (sField && sValue) {
			let filterdHash = `${sField}=${sValue}`;
			updatedHash = initSQ.length ? `${initSQ}&${filterdHash}` : filterdHash;
		} else if (initSQ) {
			updatedHash = initSQ;
		}
		return updatedHash;
		// location.hash = updatedHash;
	}

	static getCurrHashState() {
		//TODO: remove
		let currHash = decodeURI(location.hash);
		let hashMultiple = currHash.indexOf('&') > -1;
		let activeHashParams = { q: '', categFields: '' };

		let defaultQuery = 'search=';
		let searchRegx = /search=(\w|\s|-|\.|#|\+)+/gm;

		if (currHash.indexOf(defaultQuery) > -1) {
			let searchQArr = currHash.match(searchRegx);
			if (searchQArr[0].length) {
				activeHashParams.q = searchQArr[0].replace(defaultQuery, ''); // My need to codeURI
			}
		}

		// remove serch
		let catParams = currHash.replace(searchRegx, '');
		if (catParams.indexOf('=') > -1) {
			let equalSignRegx = /=/gm;
			let amperRegx = /&/gm;
			let hashRegx = /#/gm;
			catParams = catParams.replace(/#/gi, '');
			catParams = catParams.indexOf('&') == 0 ? catParams.slice(1) : catParams;
			catParams = catParams.replace(amperRegx, '|');
			catParams = catParams.replace(hashRegx, '|');
			catParams = catParams.replace(equalSignRegx, ':');
			activeHashParams.categFields = catParams;
		}

		return activeHashParams;

		// location.hash = updatedHash;
	}

	static handleFilterHashUpdate(sField, sValue) {
		let currHash = decodeURI(location.hash);

		// This is for pagination, removing page= in url.
		let pageQuery = 'page=';
		let pageRegx = /page=(\w|\s)+/gm;
		if (currHash.indexOf(pageQuery) > -1) {
			let searchQArr = currHash.match(pageRegx);
			if (searchQArr[0].length) {
				currHash = currHash.replace(pageRegx, '');
			}
		}

		let hasActiveHash = currHash.indexOf('=');
		let currQuery = `${sField}=${sValue}`;
		let filterWithAmp = new RegExp(`&${currQuery}`, 'gm');
		let firstFilter = new RegExp(`${currQuery}`, 'gm');

		// hash has the same filter - remove

		if (filterWithAmp.test(currHash)) {
			currHash = currHash.replace(`&${currQuery}`, '');
			return removeStartingAmp(currHash);
		} else if (firstFilter.test(currHash)) {
			currHash = currHash.replace(`${currQuery}`, '');
			return removeStartingAmp(currHash);
		}
		// hash doesn't have same filter add it
		currQuery = hasActiveHash ? `&${currQuery}` : currQuery;
		currQuery = `${currHash}${currQuery}`;
		return removeStartingAmp(currQuery);

		function removeStartingAmp(txt) {
			txt = txt.indexOf('#') == 0 ? txt.slice(1) : txt;
			return txt.indexOf('&') == 0 ? txt.slice(1) : txt;
		}
	}

	static getCurrFiltersArr(activeFilters) {
		// "productType:Apps|platform:SaaS"
		let filterArr = activeFilters[0].split('|');
		let filters = filterArr.map((filter) => {
			filter = filter.replace(/#/gi, '');
			let filterObj = {};
			let filterArr = filter.split(':');
			filterObj.cat = filterArr[0];
			filterObj.value = filterArr[1];

			filterObj.label = Utils.getFilterLabel(filterObj.value);
			return filterObj;
		});
		return filters;
	}

	static filterprops = '';

	static getfilterData(props) {
		Utils.filterprops = props;
	}

	static getFilterLabel(activefilterValue) {
		let rawFilterData = Utils.filterprops.filtersData;
		let activeFilterLabel = [];

		let i = 0;
		while (i < rawFilterData.length && activeFilterLabel.length <= 0) {
			let item = rawFilterData[i];
			if (item.subFilters) {
				let parentFilter = item.subFilters;

				parentFilter.forEach((childitem) => {
					let subFilterLabel = childitem.label;
					let subFilterValue = childitem.value;
					if (activefilterValue == subFilterValue) {
						activeFilterLabel.push(subFilterLabel);
					} else if (activefilterValue == subFilterLabel) {
						activeFilterLabel.push(subFilterLabel);
					}
				});
			}

			if (item.name.indexOf('=') > -1) {
				let filterLabel = item.label.trim();
				let [filterField, filterName] = item.name.split('=');
				filterField = filterField.trim();
				filterName = filterName.trim();
				if (activefilterValue == filterName) {
					activeFilterLabel.push(filterLabel);
				} else if (activefilterValue == filterLabel) {
					activeFilterLabel.push(filterLabel);
				}
			}

			i++;
		}

		return activeFilterLabel;
	}

	static async getCountryCode() {
		let countryCode = '';

		if (typeof geoip2 !== 'undefined') {
			await callInsights();
		} else {
			console.error('no geoip2 Object present!!!');
		}

		async function callInsights() {
			return await new Promise((resolve) => {
				geoip2.insights((insight) => {
					countryCode = insight.country.iso_code;
					resolve();
				});
				// if no response is available from geiop2
				if (countryCode == '') {
					setTimeout(function () {
						// if localhost
						if (location.host.indexOf(':4502') > -1) {
							countryCode = 'US';
							resolve();
						} else {
							console.error('ERROR: [geoip2 is not responding]');
							resolve();
						}
					}, 3000);
				}
			});
		}

		return countryCode;
	}
}

export class FilterAccessibility {
	constructor(filterTree) {
		let categories = [].slice.call(filterTree.querySelectorAll('.collapse'));

		if (categories.length > 0) {
			categories.forEach((category) => {
				this.findContent(category);
				// this.listenElmt(category);
			});
		}
	}

	toggleElmt(el) {
		if (el.getAttribute('aria-hidden') == 'true') {
			el.setAttribute('aria-hidden', 'false');
		} else {
			el.setAttribute('aria-hidden', 'true');
		}
	}

	findContent(category) {
		let filterContent = category.getElementsByTagName('label')[0];
		if (filterContent != null) {
			let lastFilterContent = category.lastElementChild;

			filterContent.addEventListener('keypress', (e) => {
				// let key = e.which || e.keyCode;
				this.toggleElmt(lastFilterContent);
				this.toggleElmt(e.target);
			});

			filterContent.addEventListener('click', (e) => {
				this.toggleElmt(lastFilterContent);
				this.toggleElmt(e.target);
			});
		}
	}
}

export function filterDomManipulations() {
	// media query event handler
	const isDesktop = window.matchMedia('(min-width: 1281px)');

	if (isDesktop.matches) {
		// Desktop: ensure modal is not visible and body scroll is restored
		const popoverFilter = document.querySelector('.search-results-app-filter');
		const modalOverlay = document.querySelector('.filter-modal-overlay');
		if (popoverFilter) {
			popoverFilter.setAttribute('data-expanded', 'false');
		}
		if (modalOverlay) {
			modalOverlay.setAttribute('aria-hidden', 'true');
		}
		document.body.style.overflow = '';
	}
}
